import { ReactNode } from "react";
import styles from "./FlexRow.module.css";

interface Props {
  children: ReactNode;
}

export function FlexRow({ children }: Props) {
  return <div className={styles.wrapper}>{children}</div>;
}
